import {
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  MenuItem,
  Select,
  Typography,
} from "@material-ui/core"
// import { getUsersCourseDetails, listUserInvites } from "~/actions/users"
import { useContext, useState } from "react"
import { useMutation, useQuery } from "react-query"
import { listClients } from "~/actions/clients"
import { updateAppUser } from "~/actions/users"
import AppContext from "~/contexts/App"

import Box from "~/components/Common/Box"
import useStyles from "./styles"

const EditUserDialog = () => {
  const classes = useStyles()

  const { authUser, dialogs, closeDialog, openDialog, openSnackBar } =
    useContext(AppContext)
  const thisDialog = dialogs?.["editUserDialog"] || {}
  const { open = false, data } = thisDialog

  const [loading, setLoading] = useState(false)
  const [clientId, setClientId] = useState(undefined)
  const [testUser, setTestUser] = useState(null)

  const updateAppUserMutation = useMutation(updateAppUser)
  const listClientsQuery = useQuery(["clients"], () => listClients(), {
    enabled: !!authUser,
  })

  const handleCancel = () => {
    closeDialog("editUserDialog", false)
    setClientId(undefined)
    setTestUser(null)
  }

  const handleUpdate = async () => {
    setLoading(true)
    try {
      const userId = thisDialog?.data?.id
      const client_id =
        typeof clientId === "undefined" ? data?.client_id : clientId || null
      const test_user = testUser !== null ? (testUser ? 1 : 0) : data.test_user

      await updateAppUserMutation.mutateAsync([
        userId,
        { client_id, test_user },
      ])
      closeDialog("editUserDialog", true, { client_id, test_user })
    } catch (err) {
      console.error("updateAppUserMutation", err.response.data)
      openSnackBar({ message: `${err.response.data.error}` })
    }
    setClientId(undefined)
    setLoading(false)
  }

  const renderTitle = () => {
    const name = data?.first_name + " " + data?.last_name
    return (
      <Box display="flex">
        <Box width="90%">
          <Typography variant="h2" color="primary" className={classes.name}>
            {`Edit: ${name}`}
          </Typography>
        </Box>
      </Box>
    )
  }

  const renderClientSelect = () => {
    const client_id = data?.client_id || ""
    const clients = listClientsQuery?.data
    clients.sort((a, b) => a.name.localeCompare(b.name))
    return (
      <Box display="flex" flexDirection="column">
        <Typography color="secondary" className={classes.inputLabel}>
          Client
        </Typography>
        <Select
          className={classes.clientSelect}
          variant="filled"
          disabled={loading}
          value={typeof clientId === "undefined" ? client_id : clientId}
          onChange={(e) => setClientId(e.target.value)}
        >
          <MenuItem value={""}>None</MenuItem>
          {clients.map((client) => (
            <MenuItem value={client.id} key={client.id}>
              {client.name}
            </MenuItem>
          ))}
        </Select>
      </Box>
    )
  }

  const renderTestUserCheckbox = () => {
    return (
      <Box
        display="flex"
        flexDirection="column"
        className={classes.checkboxInput}
      >
        <FormControlLabel
          style={{ margin: 0 }}
          control={
            <Checkbox
              edge="start"
              color="secondary"
              checked={testUser !== null ? testUser : !!data.test_user}
              onChange={() => setTestUser(!testUser)}
            />
          }
          label={<Typography>Test User</Typography>}
          labelPlacement="end"
          color="secondary"
        />
      </Box>
    )
  }

  const renderDialogContent = () => {
    if (listClientsQuery.isLoading || !data) {
      return null
    }
    return (
      <>
        {renderClientSelect()}
        {renderTestUserCheckbox()}
      </>
    )
  }

  const renderDialogActions = () => {
    return (
      <>
        <Button disabled={loading} onClick={() => handleCancel()}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="secondary"
          disabled={loading}
          onClick={() => handleUpdate()}
        >
          {loading ? (
            <CircularProgress size={20} style={{ color: "#222" }} />
          ) : (
            "Save"
          )}
        </Button>
      </>
    )
  }

  return (
    <Dialog
      classes={{ paperWidthSm: classes.dialogMinHeight }}
      open={open}
      onClose={() => closeDialog("editUserDialog", false)}
    >
      <DialogTitle className={classes.dialogTitle} disableTypography>
        {renderTitle()}
      </DialogTitle>

      <DialogContent>{renderDialogContent()}</DialogContent>
      <DialogActions>{renderDialogActions()}</DialogActions>
    </Dialog>
  )
}

export default EditUserDialog
